import {
    Home,
    Airplay,
    User,
} from "react-feather";
import { getMenuIconBySlug } from "./menuIcons";

const RAW_MENUITEMS = [
    {
        title: "Dashboard",
        icon: Home,
        path: "/dashboard",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        sequence: 1,
        slug: "dashboard",
    },
    // {
    //     title: "Dashboardnew",
    //     icon: Home,
    //     path: "/newDashboard",
    //     type: "link",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug:"dashboard"
    // },
    // {
    //     title: "Dashboardnew1",
    //     icon: Home,
    //     path: "/newDashboard1",
    //     type: "link",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug:"dashboard1"
    // },
    // {
    //     title: "Dashboardnew2",
    //     icon: Home,
    //     path: "/newDashboard2",
    //     type: "link",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug:"dashboard2"
    // },
    // {
    //     title: "Dashboardnew3",
    //     icon: Home,
    //     path: "/newDashboard3",
    //     type: "link",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug:"dashboard3"
    // },
    {
        title: "Dashboard new",
        icon: Home,
        path: "/newDashboard1",
        type: "link",
        active: false,
        permission: true,
        deploy: true,
        sequence: 2,
        slug:"dashboard1"
    },
    {
        title: "User management",
        icon: User,
        path: "/user",
        type: "link",
        active: false,
        permission: true,
        deploy: true,
        slug: "user_management",
        sequence: 3,
    },
    {
        title: "Property management",
        icon: Airplay,
        type: "link",
        path: "/property",
        active: false,
        permission: true,
        deploy: true,
        slug: "property_management",
    },
    {
        title: "Roles",
        icon: Airplay,
        type: "link",
        path: "/roles",
        active: false,
        permission: true,
        deploy: true,
        slug: "role_management",
    },
    {
        title: "Modules",
        icon: Home,
        path: "/module",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "module_management",
    },
    {
        title: "Masters",
        icon: Home,
        path: "/master",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "master_management",
    },
    {
        title: "Role",
        icon: Airplay,
        type: "link",
        path: "/roles",
        active: false,
        permission: true,
        deploy: true,
        slug: "role_management",
    },
    {
        title: "Module",
        icon: Home,
        path: "/module",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "module_management",
    },
    {
        title: "Master",
        icon: Home,
        path: "/master",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "master_management",
    },
    {
        title: "Agency(CP)",
        icon: Home,
        path: "/channelpartner",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "channel_management",
    },
    {
        title: "Visitors",
        icon: Home,
        path: "/visitor",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "visitor_management",
    },
    {
        title: "Closing Manager",
        icon: Home,
        path: "/closing_managers",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "closing_manager",
    },
    {
        title: "Sourcing Manager",
        icon: Home,
        path: "/sourcing_managers",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "sourcing_manager",
    },
    {
        title: "Appointment management",
        icon: Home,
        path: "/appointment",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "appointment_management",
    },
    {
        title: "Appointment Site Visit",
        icon: Home,
        path: "/appointment_site_visit",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "appointment_ site_visit",
    },
    {
        title: "Appointment With CP",
        icon: Home,
        path: "/appointment_with_cp",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "appointment_with_cp",
    },
    {
        title: "New Upload",
        icon: Home,
        path: "/newupload",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: false,
        deploy: true,
        slug: "new_upload",
    },
    {
        title: "Verify Lead",
        icon: Home,
        path: "/verify_lead",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: false,
        deploy: true,
        slug: "verify_lead",
    },
    {
        title: "Followup management",
        icon: Home,
        path: "/followup",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "followup_management",
    },
    {
        title: "Scheduled Activity",
        icon: Home,
        path: "/scheduled_activity",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "scheduled_activity",
    },
    // {
    //     title: "Chat Screen",
    //     icon: Home,
    //     path: "/chat",
    //     type: "link",
    //     badgeType: "primary",
    //     active: false,
    //     permission: true,
    //     deploy: false,
    //     slug: "chat",
    // },
    {
        title: "Support Forum",
        icon: Home,
        path: "/supportforum",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "support_forum",
    },
    {
        title: "Raise Ticket",
        icon: Home,
        path: "/raise_ticket",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "support",
    },
    {
        title: "Configuration Setting",
        icon: Airplay,
        type: "sub",
        active: false,
        permission: true,
        deploy: true,
        slug: "configuration_management",
        children: [
            {
                path: "/configurationEmail",
                title: "Configuration Email",
                type: "link",
            },
    {
                path: "/configurationMessage",
                title: "Configuration Message",
                type: "link",
            },
    {
                path: "/NotificationMapKey",
                title: "Notification Map Key",
                type: "link",
            },
            {
                path: "/edit_privacypolicy",
                title: "Edit Privacy Policy",
                type: "link",
            },
        ],
    },
    {
        title: "Access Control",
        icon: getMenuIconBySlug("access_control"),
        path: "/accessControl",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "access_control",
    },
    {
        title: "Booking management",
        icon: Airplay,
        path: "/booking_list",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "booking_management",
    },
    {
        title: "Cancel Booking",
        icon: Airplay,
        path: "/cancel_booking_list",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "cancel_booking",
    },
    {
        title: "Registration management",
        icon: Home,
        path: "/registration",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "registration_management",
    },

    // {
    //     title: "Report",
    //     icon: Home,
    //     path: "/report",
    //     type: "link",
    //     badgeType: "primary",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug: "report",
    // },
    {
        title: "Report",
        icon: Home,
        path: "/reports",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        isAdmins:true,
        slug: "report",
    },
    {
        title: "Disposition Report",
        icon: Home,
        path: "/dispositionReport",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "dispositionReport",
    },
    {
        title:"CP Appointments Report",
        icon: Home,
        path: "/getChannelPartnerAppointments",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "getChannelPartnerAppointments",
    },
    // {
    //     title: "Channel Partner Report",
    //     icon: Home,
    //     path: "/getAllChanelPartnerData",
    //     type: "link",
    //     badgeType: "primary",
    //     active: false,
    //     permission: true,
    //     deploy: true,
    //     slug: "getAllChanelPartnerData",
    // },
    {
        title: "Project Details Report",
        icon: Home,
        path: "/pdr_report",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "project_details_report",
    },
    {
        title: "Report Management",
        icon: Airplay,
        type: "sub",
        active: false,
        permission: true,
        deploy: true,
        slug: "report_management",
        children: [
            {
                path: "/report",
                title: "Report",
                type: "link",
            },
    {
                path: "/kpi_tracker_report",
                title: "KPI Tracker Report",
                type: "link",
            },
            // {
            //     path:"/rolewiseReport",
            //     title:"Role based Report",
            //     type:"link"
            // },
    {
                path: "/pdr_report",
                title: "Project Details Report",
                type: "link",
                slug: "project_details_report",
            },
            // {
            //     path: "/user_activity_report",
            //     title: "User Activity Report",
            //     type: "link",
            // },
    {
                path:"/dispositionReport",
                title:"Disposition Report",
                type:"link"
            },
    {
                path:"/ChannelPartnerReport",
                title:"CP Report",
                type:"link"
            },
    {
                path:"/ChannelPartnerAppointmentsList",
                title:"CP Appointment Report",
                type:"link"
            },
    {
                path: "/mdocAuditLog",
                title: "MDoc Audit Log",
                type: "link",
                slug: "mdoc_audit_log",
                isSuperAdminOnly: true,
            },
        ],
    },
    {
        title: "User Announcement",
        icon: Home,
        path: "/user_announcement",
        type: "link",
        badgeType: "primary",
        active: false,
        permission: true,
        deploy: true,
        slug: "user_announcement",
    },

];

export const MENUITEMS = RAW_MENUITEMS.map((item) => ({
  ...item,
  icon: getMenuIconBySlug(item.slug) || item.icon,
}));
